import React, { useEffect, useState } from "react";
import Header from "../Componets/Header";
import Footer from "../Componets/Footer";
import Modal from "../Componets/Modal";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

function Certificate() {
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Preloader timer
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading && (
        <div id="pre-load">
          <div id="loader" className="loader">
            <div className="loader-container">
              <div className="loader-icon">
                <img src="/assets/images/favicon.png" alt="Loader" />
              </div>
            </div>
          </div>
        </div>
      )}
      <>
        <div className="rs-smoother-yes rtl">
          <div id="rs-mouse">
            <div id="cursor-ball"></div>
          </div>
          <Header />

          <Helmet>
            <title>{`Certificate | ${process.env.REACT_APP_COMPANYNAME} | ${process.env.REACT_APP_PHONE1}`}</title>

            <meta
              name="description"
              content="Explore our complete range of high-precision cutting tools including drills, endmills, ballnose endmills, and reamers for CNC & VMC machining."
            />

            <link
              rel="canonical"
              href={`${process.env.REACT_APP_SITE_URL}/certificate`}
            />

            <meta
              property="og:url"
              content={`${process.env.REACT_APP_SITE_URL}/certificate`}
            />

            <meta
              property="og:title"
              content={`Cutting Tools Products | ${process.env.REACT_APP_COMPANYNAME}`}
            />

            <meta
              property="og:description"
              content="Discover precision cutting tools manufactured for high performance CNC & VMC machining applications."
            />

            <meta property="og:type" content="website" />
          </Helmet>

          {/* Banner */}
          <section className="inner-page-banner">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb justify-content-center">
                      <li className="breadcrumb-item">
                        <Link to="/" title="pristine precision tools home page">
                          Home
                        </Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Certificate
                      </li>
                    </ol>
                  </nav>
                  <div className="title text-white text-center">
                    <h1 className="text-white">Certificate</h1>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div className="container">
            <div className="d-flex justify-content-center gap-5 certificate-wrapping">
              {/* <div className="w-100"> */}
              {/* <div className="mt-5 section-space section-space-certificate">
                    <div className="certificate-list">
                      <div className="item">
                        <div className="img">
                          <div
                            className="img-bg"
                            onClick={() => setIsModalOpen(true)}
                          >
                            <img
                              src="/assets/images/certificate.jpg"
                              alt="ISO 9001:2015"
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        </div>

                        <div className="certificate-name">
                          <h5>ISO 9001:2015</h5>
                          <p>
                            Engineerable UK operates an ISO 9001:2015 certified
                            Quality Management System...
                          </p>
                        </div>
                      </div>
                    </div>
                  </div> */}
              {/* </div> */}

              {/* <div className="w-100"> */}
              <div className="mt-5 section-space section-space-certificate section-space-certificate-res">
                <div className="certificate-list">
                  <div className="item">
                    <div className="img">
                      <div
                        className="img-bg"
                        onClick={() => setIsModalOpen(true)}
                      >
                        <img
                          src="/assets/images/PRISTINE PRECISION TOOLS - RAJKOT - ISO 9001 CERTIFICATE-1.png"
                          alt="ISO 9001:2015"
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </div>

                    <div className="certificate-name">
                      <h5>ISO 9001:2015</h5>
                      <p>
                        Pristine Precision Tools operates an ISO 9001:2015
                        certified Quality Management System...
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* </div> */}
            </div>
          </div>

          <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
            <img
              src="/assets/images/PRISTINE PRECISION TOOLS - RAJKOT - ISO 9001 CERTIFICATE-1.png"
              alt="Certificate"
            />
          </Modal>

          <Footer />
          {/* Backtotop start  */}
          <div className="backtotop-wrap cursor-pointer has-theme-red">
            <svg
              className="backtotop-circle svg-content"
              width="100%"
              height="100%"
              viewBox="-1 -1 102 102"
            >
              <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
            </svg>
          </div>
          {/* <!-- Backtotop end --> */}
        </div>
      </>
    </>
  );
}

export default Certificate;
